export default __webpack_public_path__ + "static/business-eb5a0b9d18ac8e8fafb0627b9d2f97bd.png";